import ActiveOptionViewState, { ActiveItem } from '../../store/schema/ActiveOptionViewState';
import loadAccountOption from '../../actions/account/loadAccountOption';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

/**
 * This mutator will be called when loadAccountOption action is dispatched by clicking on account setting
 */
const loadAccountMutator = mutator(loadAccountOption, () => {
    getOptionsStore().activeViewState = {
        name: ActiveItem.Account,
        isDirty: false,
        isLoading: false,
    } as ActiveOptionViewState;
});

export default loadAccountMutator;
